<template>
	<box :customer="true" :autoLoad="true" :ref="boxRef" title="快递公司" :width="1000" :index="0" @hide="hide"
		@submit="submit" moduleName="parcelbox" :store="store" selectType="radio" @boxdataload="boxdataload" />

</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				default: () => {
					return 'order'
				}
			},
			mainfApi: {
				default: () => {
					return null
				}
			},
			orderid: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				index: 0,
				deliveryList:[],
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [ {
						type: "",
						field: 'distrParamName',
						title: '公司名称',
						render: ''

					},{
						type: "",
						field: 'distrName',
						title: '快递名称',
						render: ''

					}, {
						field: 'storageName',
						title: '推荐仓库',
						render: ''
					}, {
						field: 'targettPrice',
						title: '运费',
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 100,
						enabled: false,
						pageSizes: [20, 50, 200],
						force: true
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			show() {
				if (this.box.getTable()) {
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list() {
				return new Promise((resolve) => {

					resolve({list:this.deliveryList})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>